import React from 'react';
import NavbarTop from '../components/NavbarTop';
import NavbarBottom from '../components/NavbarBottom';
import DeviceDetails from '../components/DeviceDetails';

const DeviceProfile = () => {
  return (
    <div>
      <NavbarTop />
      <DeviceDetails />
      <NavbarBottom />
    </div>
  );
};

export default DeviceProfile;
